export default __webpack_public_path__ + "static/media/RalphWiggum.39da0c23.png";